module.exports = __webpack_public_path__ + "img/awards.77b28d4.webp";